module.exports = __webpack_public_path__ + "images/avatars/male/9.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/9.png
// module id = ifp+
// module chunks = 154